export const version = {
    major: 0,
    minor: 9,
    patch: 0,
};
